export default __webpack_public_path__ + "static/media/phone.ac5bebad.svg";